import React from 'react'
import { Typography, makeStyles } from '@material-ui/core'

const useStyle = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    textAlign: 'center'
  },
  content: {
    textAlign: 'center'
  }
}))

export default ({ title, content }) => {
  const classes = useStyle()
  return (
    <div>
      <Typography gutterBottom className={classes.title} variant='h5'>{title}</Typography>
      <Typography variant='body1' className={classes.content} >{content}</Typography>
    </div>
  )
}